import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  AziendeBase,
  ENUM_FILE_DATA_TYPES_BASE64_PREFIX,
  Environment,
  IAziendaBaseAddModel,
  ModelNumBytes,
} from '../../models/-index';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ModelNumStr } from '../../models/-index';
import { CrudGenericsService } from '../common/crud-generics';

@Injectable()
export class AziendeBaseService extends CrudGenericsService<AziendeBase, number> {
  private base: string;
  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/AziendeBase`);
    this.base = `${env.apiUrl}/api/AziendeBase/`;
  }

  GetCurrent_AzBase(): Observable<AziendeBase> {
    const u = `${this.base}GetCurrent_AzBase`;
    return this.http.get<AziendeBase>(u);
  }
  Get4Select_GetCurrent(): Observable<ModelNumStr> {
    const u = `${this.base}Get4Select_GetCurrent`;
    return this.http.get<ModelNumStr>(u);
  }

  Get4Select_All(): Observable<ModelNumStr[]> {
    const u = `${this.base}Get4Select_All`;
    return this.http.get<ModelNumStr[]>(u);
  }
  //------- loghi : trasforma già in jpeg per il rendering in src formato stringa ----- //
  /* GetLogoWeb(): Observable<string> {
    const u = `${this.base}GetLogoWeb`;
    return this.http.get<ModelNumBytes>(u).pipe(
      take(1),
      map((x: ModelNumBytes) => {
        if (x && x.Bytes) {
          return ENUM_FILE_DATA_TYPES_BASE64_PREFIX.JPEG + x.Bytes.toString();
        } else {
          return null;
        }
      })
    );
  }*/

  GetLogoDoc(): Observable<string> {
    const u = `${this.base}GetLogoDoc`;
    return this.http.get<ModelNumBytes>(u).pipe(
      take(1),
      map((x: ModelNumBytes) => {
        if (x && x.Bytes) {
          return ENUM_FILE_DATA_TYPES_BASE64_PREFIX.JPEG + x.Bytes.toString();
        } else {
          return null;
        }
      })
    );
  }

  /*
  GetAll_ICanSee_DRU(fdu: string, h: boolean = false): Observable<AziendeBase[]> {
    const u = this.base + 'GetAll_ICanSee_DRU?fdu=' + fdu + '&h=' + h;
    return this.http.get<AziendeBase[]>(`${u}`);
  }*/
  Get4Select_ICanSee_DRU(funzione: string): Observable<ModelNumStr[]> {
    const u = `${this.base}Get4Select_ICanSee_DRU?funzione=${funzione}`;
    return this.http.get<ModelNumStr[]>(u);
  }

  CreateAziendaBaseAddModel(model: IAziendaBaseAddModel) {
    const u = `${this.base}CreateAziendaBaseAddModel`;
    return this.http.post(u, model);
  }
}
